module.exports = __webpack_public_path__ + "img/orange_124.46d7894e.png";